export default __webpack_public_path__ + "static/media/review10.5dcc4897.jpg";